module.exports = __webpack_public_path__ + "static/media/component-map-card.3127acd4.png";